import { useAppSelector } from 'store/hooks';
import { selectRemovePayTab } from '../selectors';
import { isWeb } from '../../../constants';
/**
 * Whether the remove-pay-tab experience is active: the feed pay button and
 * groups card replace the Pay tab. Web keeps the default experience as the
 * pay and group screens are not registered there.
 */
export const useRemovePayTabExperience = () => {
    const removePayTab = useAppSelector(selectRemovePayTab);
    return !isWeb && removePayTab;
};
